import script from "./SideBarContent.vue?vue&type=script&setup=true&lang=ts"
export * from "./SideBarContent.vue?vue&type=script&setup=true&lang=ts"

import "./SideBarContent.vue?vue&type=style&index=0&id=2aa44629&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2aa44629"]])

export default __exports__